import type {
  LeadTimeStrategyBuilder,
  LeadTimeStrategyResultBuilder,
} from '@calculations/lead-time/builders';
import type { Weeks } from '@calculations/lead-time/time';

export const ConstantValue = 'ConstantValue' as const;

export type ConstantValue = typeof ConstantValue;

export type ConstantValueLeadTimeStrategy = LeadTimeStrategyBuilder<
  ConstantValue,
  Weeks
>;

export type ConstantValueLeadTimeStrategyResult =
  LeadTimeStrategyResultBuilder<ConstantValue>;
